"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { authService } from "@/lib/auth";
import Loading from "@/components/shared/Loading";

export default function AuthRedirect() {
  const router = useRouter();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      if (authService.isAuthenticated()) {
        router.push("/conecta");
      } else {
        setIsChecking(false);
      }
    };

    // Verificar autenticação imediatamente
    checkAuth();
  }, [router]);

  // Mostrar loading enquanto verifica ou está autenticado
  if (isChecking) {
    return <Loading />;
  }

  return null;
}
